import React from 'react';
import { LandingHeader } from '../../../shared/components/layout/LandingHeader';
import { PageHeader } from '../../../shared/components/layout/pageHeader';
import { Footer } from '../../../shared/components/layout/Footer';

export default function Privacy() {
  return (
    <div className="min-h-screen flex flex-col">
      <LandingHeader color="#361E06" />
      
      <div className="flex-grow max-w-3xl mx-auto px-4 py-8 sm:px-6 lg:px-8">
        <PageHeader
          headline="Privacy Policy"
          subheadline="Last updated: March 2024"
        />

        <div className="prose prose-lg mt-6 text-gray-600 max-w-none">
          <div className="space-y-6">
            <div className="bg-white rounded-lg shadow-sm p-6 space-y-4">
              <h2 className="text-xl font-semibold text-[#361E06] border-b border-gray-200 pb-3">1. Introduction</h2>
              <p className="text-base leading-relaxed">
                At Theos ("we," "us," or "our"), we take your privacy seriously. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our AI-powered Bible study companion service ("the Service"). Please read this privacy policy carefully. By using the Service, you consent to the practices described in this policy.
              </p>
            </div>

            <div className="bg-white rounded-lg shadow-sm p-6 space-y-4">
              <h2 className="text-xl font-semibold text-[#361E06] border-b border-gray-200 pb-3">2. Information We Collect</h2>
              <div className="space-y-4">
                <div>
                  <h3 className="text-lg font-medium text-[#361E06] mb-2">2.1 Information You Provide</h3>
                  <p className="text-base leading-relaxed">
                    We collect information that you voluntarily provide when using our Service, including:
                  </p>
                  <ul className="list-disc pl-6 space-y-1 mt-2">
                    <li>Account information (name, email, profile picture)</li>
                    <li>Authentication data when using Google Sign-in</li>
                    <li>User-generated content (notes, bookmarks, chat messages)</li>
                    <li>Subscription and payment information</li>
                    <li>Communication preferences</li>
                    <li>Support inquiries and feedback</li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-lg font-medium text-[#361E06] mb-2">2.2 Automatically Collected Information</h3>
                  <p className="text-base leading-relaxed">
                    When you use our Service, we automatically collect certain information, including:
                  </p>
                  <ul className="list-disc pl-6 space-y-1 mt-2">
                    <li>Device information (type, operating system, unique identifiers)</li>
                    <li>Log data (IP address, browser type, pages visited)</li>
                    <li>Usage patterns and interactions</li>
                    <li>Performance and error data</li>
                    <li>Location information (with your consent)</li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-lg font-medium text-[#361E06] mb-2">2.3 AI Interaction Data</h3>
                  <p className="text-base leading-relaxed">
                    We collect and process data related to your interactions with our AI system:
                  </p>
                  <ul className="list-disc pl-6 space-y-1 mt-2">
                    <li>Questions and prompts you submit</li>
                    <li>AI-generated responses</li>
                    <li>Context of Bible study sessions</li>
                    <li>Feedback on AI responses</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow-sm p-6 space-y-4">
              <h2 className="text-xl font-semibold text-[#361E06] border-b border-gray-200 pb-3">3. How We Use Your Information</h2>
              <div className="space-y-4">
                <div>
                  <h3 className="text-lg font-medium text-[#361E06] mb-2">3.1 Core Service Functionality</h3>
                  <p className="text-base leading-relaxed">
                    We use your information to:
                  </p>
                  <ul className="list-disc pl-6 space-y-1 mt-2">
                    <li>Provide and maintain the Service</li>
                    <li>Process and fulfill subscription requests</li>
                    <li>Authenticate your identity and maintain security</li>
                    <li>Personalize your experience</li>
                    <li>Improve our AI responses and recommendations</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-6 text-sm text-gray-500 text-center">
            <p>For any questions about our Privacy Policy, please contact us at privacy@theos.chat</p>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
} 